// extracted by mini-css-extract-plugin
module.exports = {"LayoutContainer":"Layout_LayoutContainer__34vxo","ContentContainer":"Layout_ContentContainer__3qBo4","FooterContainer":"Layout_FooterContainer__30t4q"};